<template>
  <span class="svg-ico-check">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5123 7.38029C20.805 7.67345 20.8046 8.14832 20.5114 8.44095L10.6585 18.2764C10.3656 18.5689 9.89106 18.5687 9.59835 18.276L4.68061 13.3582C4.38771 13.0653 4.38771 12.5905 4.68061 12.2976C4.9735 12.0047 5.44837 12.0047 5.74127 12.2976L10.1291 16.6854L19.4517 7.37936C19.7448 7.08672 20.2197 7.08714 20.5123 7.38029Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this && this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default () { return this && this.$store.state.color['coolGrey-50'] } },
    isFixedColor: { type: Boolean },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
